import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const regimesForAsset = api(async (id) => {
    if (!id) return []
    return query(
        gql`
            query GetRegimesForAsset($id: String!) {
                regimesForAsset(id: $id) {
                    id
                    title
                    where {
                        scheduleId
                        title
                        group
                    }
                }
            }
        `,
        {
            id,
        },
        {
            returns: "regimesForAsset",
        }
    )
})
